import * as React from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import {
  CurrencyLira,
  Language,
  MoreVert,
  Twitter,
  ViewWeek,
} from "@mui/icons-material";

export default function VerticalDividers() {
  return (
    <div>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          width: "fit-content",
          border: (theme) => `1px solid lightgray`,
          borderRadius: 3,
          bgcolor: "white",
          color: "text.secondary",
          "& svg": {
            m: 1.5,
          },
          "& hr": {
            mx: 0.5,
          },
        }}
      >
        <Language />
        <Divider orientation='vertical' flexItem />
        <CurrencyLira />
        <Divider orientation='vertical' flexItem />
        <Twitter />
        <Divider orientation='vertical' flexItem />
        <ViewWeek />
        <Divider orientation='vertical' flexItem />
        <MoreVert sx={{ color: "black" }} />
      </Box>
    </div>
  );
}
